/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import { responsiveStyles } from "../../commons/styles";
import { navBarStyle } from "./styles";
import { NavLink, useParams } from "react-router-dom";
import {
  joinUsNowText,
  login,
  buttonActions,
  navBarImageLink,
  navBarImageLinkWhite,
  getPageTitle,
  GAEvents,
} from "../../constants/commons";
import { INavBarProps } from "./interfaces";
import { Drawer } from "antd";
import { useIsTab, useIsMobile } from "../../hooks/useIsMobile";
import { triggerUserLogin, getImgURLFromBufferData } from "../../utils/helpers";
import { useUserContext } from "../../hooks/cookieHooks";
import { Avatar } from "antd";
import personOutlinedIcon from "../../assets/person-outlined-icon.svg";
import hamburgerWhiteIcon from "../../assets/hamburger-white.svg";
import hamburgerBlackIcon from "../../assets/hamburger-black.svg";
import dropdownBlackIcon from "../../assets/dropdown-arrow-black.svg";
import dropdownWhiteIcon from "../../assets/dropdown-arrow-white.svg";
import backIcon from "../../assets/back-arrow.svg";
import { CustomButton } from "../../atoms/CustomButton";
import {
  CustomButtonColor,
  CustomButtonTypes,
} from "../../atoms/CustomButton/interface";
import { URL } from "../../API/urlEndpoints";
import useSTR from "react-str";
import { getData } from "../../utils/fetchers";
import { GA_Event } from "../../utils/reactGA";

export const NavBar: React.FC<INavBarProps> = (props: INavBarProps) => {
  const { partnerID } = useParams() as any;
  const user = useUserContext();
  const { onButtonClickAction, isProfilePictureUpdated } = props;
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [showUserDropDown, setShowUserDropDown] = React.useState<boolean>(
    false
  );
  const [profilePicture, setProfilePicture] = React.useState<string>("");
  const { navLinks, blackNav } = props;
  const isMobileView = useIsMobile();
  const isTabView = useIsTab();

  // ICON which displays on the left of the NAVBAR
  const imageComponent = () => {
    return (
      <img
        src={navBarImageLink}
        alt="Partner Fit"
        className="responsive-logo-width drawer-mobile-image-style"
        onClick={() => {
          window.location.href = "/";
        }}
      />
    );
  };

  const onButtonClick = (type: string) => {
    document.body.removeAttribute("style");
    if (type === buttonActions.SIGNIN) {
      triggerUserLogin();
    } else {
      setOpenDrawer(false);
      onButtonClickAction && onButtonClickAction(type);
    }
  };

  // Function which is called when the user selects a link in the Drawer component
  const closeOpenedDrawerComponent = React.useCallback(() => {
    setOpenDrawer(false);
  }, []);

  const addLink =
    navLinks &&
    navLinks.map((data, key) => {
      return (
        <div key={key}>
          <li className="nav-item active " key={key}>
            <NavLink
              exact
              activeClassName="selected-link"
              className="nav-link mobile-tablet-responsive-margin"
              to={data.link}
            >
              <button
                onClick={closeOpenedDrawerComponent}
                className="border-0 bg-none"
              >
                {data.label} <span className="sr-only">(current)</span>
              </button>
            </NavLink>
          </li>
          {(isMobileView || isTabView) && (
            <div className="horizontal-line"></div>
          )}
        </div>
      );
    });

  const linkTagsComponent = () => {
    return (
      <ul
        className={
          isMobileView || isTabView
            ? "drawer-links-style p-0 mt-4"
            : "navbar-nav col"
        }
      >
        {addLink}
      </ul>
    );
  };

  const userDropdownRef = React.useRef<HTMLUListElement>(null);

  // DO NOT DELETE

  React.useEffect(() => {
    if (showUserDropDown) {
      window.addEventListener("click", closeUserDropdown);
    } else {
      removeDropdownListener();
    }
    return () => window.removeEventListener("click", closeUserDropdown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showUserDropDown]);

  const closeUserDropdown = (e: any) => {
    if (
      showUserDropDown &&
      userDropdownRef.current &&
      !userDropdownRef.current.contains(e.target)
    ) {
      setShowUserDropDown(false);
    }
  };
  const removeDropdownListener = () => {
    window.removeEventListener("click", closeUserDropdown);
  };

  const toggleUserDropdown = () => {
    setShowUserDropDown((prevState) => {
      if (prevState) {
        return false;
      } else {
        return true;
      }
    });
  };

  const [
    ,
    {
      result: getBasicInfoPageData,
      revalidator: refetchBasicInfoPageData,
      loading: getBasicInfoLoading,
      error: getBasicInfoError,
    },
  ] = useSTR(getData);

  React.useEffect(() => {
    if (isProfilePictureUpdated === true || isProfilePictureUpdated === false) {
      refetchBasicInfoPageData(`${URL.getProfilePicture(user.empId)}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProfilePictureUpdated]);

  React.useEffect(() => {
    if (!getBasicInfoLoading && getBasicInfoPageData && !getBasicInfoError) {
      const documentsFromServer = getImgURLFromBufferData(getBasicInfoPageData);
      documentsFromServer &&
      documentsFromServer.length > 0 &&
      documentsFromServer[0].data
        ? setProfilePicture(documentsFromServer[0].thumbUrl)
        : setProfilePicture(personOutlinedIcon);
    }
  }, [getBasicInfoLoading, getBasicInfoPageData, getBasicInfoError]);

  const userAvatar = (
    <React.Fragment>
      <Avatar
        icon={
          <img
            src={
              getBasicInfoLoading || !profilePicture.length
                ? personOutlinedIcon
                : profilePicture
            }
            alt="user img"
          />
        }
      />
      {!!user && !!user.memberships && (
        <div className="name-container">
          <div className="user-name">{user.firstName}</div>
          <div className="user-profession">{user.memberships[0].context}</div>
        </div>
      )}
    </React.Fragment>
  );
  const userOptions = (
    <ul
      className={`dropdown-list ${
        showUserDropDown ? "dropdown-list-active" : ""
      }`}
      ref={userDropdownRef}
    >
      {/* <li key={0}>
        <span>Edit Details</span>
      </li> */}
      <li
        key={1}
        onClick={() => {
          logout();
        }}
      >
        <span>Logout</span>
      </li>
    </ul>
  );

  const userAvatarWebComponent = () => {
    return (
      <div
        className="user-info-container"
        onClick={(e) => {
          e.stopPropagation();
          toggleUserDropdown();
        }}
      >
        {userAvatar}
        {props.blackNav && <img src={dropdownWhiteIcon} alt="" />}
        {!props.blackNav && <img src={dropdownBlackIcon} alt="" />}
        {showUserDropDown && (
          <div className="user-dropdown-container">{userOptions}</div>
        )}
      </div>
    );
  };
  const userAvatarMobileComponent = () => {
    return <div className="user-info-container">{userAvatar}</div>;
  };
  const logout = () => {
    window.location.href = "/logout";
  };
  const onClose = () => {
    setOpenDrawer(false);
  };
  const openDrawerComponent = () => {
    setOpenDrawer(true);
  };

  return (
    <span css={[responsiveStyles, navBarStyle(blackNav)]}>
      <nav
        className={`${
          isMobileView || isTabView
            ? "navbar navbar-expand-lg navbar-light static px-1"
            : "navbar navbar-expand-lg navbar-light static navbar-padding-container"
        } ${props.blackNav ? "black-nav" : ""}`}
      >
        {getPageTitle(partnerID) && (
          <div className="d-flex">
            <button
              className={
                isMobileView || isTabView
                  ? "border-0 p-0  user-button-style"
                  : "d-none"
              }
              onClick={() => {
                window.location.href = "/";
              }}
            >
              <img src={backIcon} alt="" />
            </button>
            <h5 className="mb-0 mt-1">{getPageTitle(partnerID)}</h5>
          </div>
        )}
        {!getPageTitle(partnerID) && (
          <div>
            <button
              className={
                isMobileView || isTabView
                  ? "border-0 p-0  user-button-style"
                  : "d-none"
              }
              onClick={openDrawerComponent}
            >
              {!props.blackNav && (
                <img src={hamburgerBlackIcon} alt="partner-fit" />
              )}
              {props.blackNav && (
                <img src={hamburgerWhiteIcon} alt="partner-fit" />
              )}
            </button>
            <img
              src={blackNav ? navBarImageLinkWhite : navBarImageLink}
              alt=""
              className="responsive-logo-width"
              onClick={() => {
                window.location.href = "/";
              }}
            />
          </div>
        )}
        <div className="d-md-none d-xs-block mr-2">
          {user.empId && userAvatarMobileComponent()}
          {!user.empId && (
            <CustomButton
              onClick={() => {
                GA_Event(GAEvents.LOGIN, "clicked", "from mobile Navbar");
                onButtonClick(buttonActions.SIGNIN);
              }}
              color={CustomButtonColor.SECONDARY}
              type={CustomButtonTypes.BUTTON}
            >
              <span className="responsive-text">{login}</span>
            </CustomButton>
          )}
        </div>

        <div className="collapse navbar-collapse my-1" id="navbarNav">
          {linkTagsComponent()}
          {!user.empId && (
            <div className="">
              <CustomButton
                onClick={() => {
                  GA_Event(GAEvents.LOGIN, "clicked", "from Navbar");
                  onButtonClick(buttonActions.SIGNIN);
                }}
                color={CustomButtonColor.SECONDARY}
                type={CustomButtonTypes.BUTTON}
              >
                <span className="responsive-text">{login}</span>
              </CustomButton>
              <CustomButton
                className=" px-4 ml-2"
                onClick={() => {
                  GA_Event(GAEvents.JOIN_US_NOW, "clicked", "from Navbar");
                  onButtonClick(buttonActions.SIGNUP);
                }}
                color={CustomButtonColor.PRIMARY}
                type={CustomButtonTypes.BUTTON}
              >
                <span className="responsive-text">{joinUsNowText}</span>
              </CustomButton>
            </div>
          )}
          {user.empId && <div>{userAvatarWebComponent()}</div>}
        </div>
        <Drawer
          placement="left"
          onClose={onClose}
          visible={openDrawer}
          width={`${isMobileView ? "90%" : "45%"}`}
        >
          <span css={[responsiveStyles, navBarStyle(blackNav)]}>
            <div className="col p-0">{imageComponent()}</div>
            {linkTagsComponent()}
            <div className="row mobile-view-navFooter-style mb-3">
              {!user.empId && (
                <React.Fragment>
                  <div className="col-5 p-0">
                    <button
                      className="button-style-white col user-button-style"
                      onClick={() => {
                        GA_Event(GAEvents.LOGIN, "clicked", "from Drawer");
                        onButtonClick(buttonActions.SIGNIN);
                      }}
                    >
                      <span className="responsive-text">{login}</span>
                    </button>
                  </div>
                  <div className="col-6 p-0 offset-1">
                    <button
                      className="button-style-red col user-button-style"
                      onClick={() => {
                        GA_Event(
                          GAEvents.JOIN_US_NOW,
                          "clicked",
                          "from Drawer"
                        );
                        onButtonClick(buttonActions.SIGNUP);
                      }}
                    >
                      <span className="responsive-text">{joinUsNowText}</span>
                    </button>
                  </div>
                </React.Fragment>
              )}
              {user.empId && (
                <CustomButton
                  color={CustomButtonColor.PRIMARY}
                  type={CustomButtonTypes.BUTTON}
                  onClick={(e) => {
                    logout();
                  }}
                  className="side-nav-logout-btn"
                >
                  LOGOUT
                </CustomButton>
              )}
            </div>
          </span>
        </Drawer>
      </nav>
    </span>
  );
};
